<template>
	<nav v-if="data" class="navbar navbar-default navbar-custom">
		<div class="container-fluid bold-400">
			<div class="navbar-header navbar-header-custom">
				<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
					<span class="sr-only">Toggle navigation</span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
				<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/budgets/' + data.id" class="navbar-brand navbar-brand-custom bold">
					Presupuesto {{ $platform.setting.number_symbol }}{{ data.id }}
				</router-link>
			</div>

			<div class="collapse navbar-collapse navbar-collapse-custom" id="bs-example-navbar-collapse-1">
				<ul class="nav navbar-nav">
					<template v-if="data.customer">
						<li :class="'list-group-item-' + data.status.class">
							<a @click="$refs.ChangeStatus.open(data)" href="javascript:void(0)">
								<span v-html="data.status.icon"></span>
								{{ data.status.name }}
							</a>
						</li>
					</template>
					<template v-else>
						<li :class="'disabled list-group-item-' + data.status.class">
							<a href="javascript:void(0)">
								<span v-html="data.status.icon"></span>
								{{ data.status.name }}
							</a>
						</li>
					</template>
					<template v-if="data.customer">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/customers/' + data.customer.id" :title="data.customer.name">
								<i class="fa fa-address-card-o fa-fw" aria-hidden="true"></i>
								Cliente <template v-if="$platform.setting.customers.custom_reference">{{ data.customer.reference }}</template><template v-else>{{ $platform.setting.number_symbol }}{{ data.customer.id }}</template>
							</router-link>
						</li>
					</template>
					<template v-else>
						<li>
							<a @click="$refs.addCustomer.open()" href="javascript:void(0)">
								<i class="fa fa-plus fa-fw" aria-hidden="true"></i>
								Añadir cliente
							</a>
						</li>
					</template>
					<template v-if="data.request">
						<li @click="$refs.requestShow.open(data.request)" :title="data.request.title">
							<a href="javascript:void(0)">
								<i class="fa fa-info-circle fa-fw"></i>
								Solicitud {{ $platform.setting.number_symbol }}{{ data.request.id }}<br>
							</a>
						</li>
					</template>
					<template v-if="data.order">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders/' + data.order.id">
								<i class="fa fa-file-text fa-fw" aria-hidden="true"></i>
								Pedido venta {{ $platform.setting.number_symbol }}{{ data.order.id }}
							</router-link>
						</li>
					</template>
					<template v-else>
						<template v-if="!$platform.setting.auto_generate_orders">
							<template v-if="data.budget_status_id == 5">
								<li>
									<a @click="generateOrder()" href="javascript:void(0)">
										<i class="fa fa-plus fa-fw" aria-hidden="true"></i>
										Pedido
									</a>
								</li>
							</template>
						</template>
					</template>
					<template v-if="data.invoice">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/invoices/' + data.invoice.id">
								<i aria-hidden="true" class="fa fa-clipboard fa-fw"></i>
								Factura {{ $platform.setting.number_symbol }}{{ data.invoice.prefix }}{{ data.invoice.number }}
							</router-link>
						</li>
					</template>
				</ul>
				<form class="navbar-form navbar-left">
					<template v-if="data.assigned">
						<template v-if="data.assigned.profile">
							<template v-if="data.assigned.profile.avatar">
								<div class="form-group">
									<a @click="$refs.Assigned.open(data)" href="javascript:void(0)">
										<img :src="data.assigned.profile.avatar" class="img-circle" width="30px"
											:alt="data.assigned.email"
											:title="data.assigned.email">
										<span class="visible-xs-inline">
											{{ data.assigned.email }}
										</span>
									</a>
								</div>
							</template>
						</template>
					</template>
				</form>
				<ul class="nav navbar-nav navbar-right">
					<template v-if="data.customer">
						<template v-if="data.customer.places">
							<template v-if="data.customer.places.length > 1">
								<li>
									<a @click="$refs.places.open()" href="javascript:void(0)">
										<span class="hidden-xs">
											<i class="fa fa-map-marker" aria-hidden="true"></i>
										</span>
										<span class="visible-xs-inline">
											<i class="fa fa-map-marker fa-fw" aria-hidden="true"></i>
										</span>
										<span class="visible-xs-inline">
											Cambiar localización
										</span>
									</a>
								</li>
							</template>
						</template>
					</template>
					<template v-if="data.budget_status_id == 1">
						<li v-if="data.customer">
							<a @click="removeCustomer()" href="javascript:void(0)">
								<span class="hidden-xs">
									<i class="fa fa-user-times fa-fw" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									<i class="fa fa-user-times fa-fw" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									Remover cliente
								</span>
							</a>
						</li>
					</template>
					<template v-if="data.lock">
						<li>
							<a @click="lock()" href="javascript:void(0)" :title="$t('interface.unlock') | ucfirst">
								<span class="hidden-xs">
									<i class="fa fa-lock" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									<i class="fa fa-lock fa-fw" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									{{ $t('interface.unlock') | ucfirst }}
								</span>
							</a>
						</li>
					</template>
					<template v-else>
						<li>
							<a @click="lock()" href="javascript:void(0)" :title="$t('interface.lock') | ucfirst">
								<span class="hidden-xs">
									<i class="fa fa-unlock" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									<i class="fa-fw fa fa-unlock" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									{{ $t('interface.lock') | ucfirst }}
								</span>
							</a>
						</li>
					</template>
					<li>
						<a @click="$refs.paymentConditions.open()" href="javascript:void(0)" :title="$t('interface.payment_conditions') | ucfirst">
							<span class="hidden-xs">
								<i class="fa fa-money" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-money fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								{{ $t('interface.payment_conditions') | ucfirst }}
							</span>
						</a>
					</li>
					<li>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/budgets/' + data.id + '/docs'" :title="$tc('interface.doc', 2) | ucfirst">
							<span class="hidden-xs">
								<i class="fa fa-folder-open-o" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-folder-open-o fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								{{ $tc('interface.doc', 2) | ucfirst }}
							</span>
							<span v-if="data.info.media > 0" class="label label-rouded label-info">{{ data.info.media }}</span>
						</router-link>
					</li>
					<li @click="$refs.SendEmail.open()">
						<a href="javascript:void(0)" :title="$t('interface.send') | ucfirst">
							<span class="hidden-xs">
								<i class="fa fa-paper-plane" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-paper-plane fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								{{ $t('interface.send') | ucfirst }}
							</span>
						</a>
					</li>
					<li @click="doPrint()">
						<a href="javascript:void(0)" :title="$t('interface.print') | ucfirst">
							<span class="hidden-xs">
								<i class="fa fa-print" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-print fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								{{ $t('interface.print') | ucfirst }}
							</span>
						</a>
					</li>
					<li>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/management/budgets/' + data.random" target= '_blank' title="PDF">
							<span class="hidden-xs">
								<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-file-pdf-o fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								Ver PDF
							</span>
						</router-link>
					</li>
					<li @click="openSettings()">
						<a href="javascript:void(0)" :title="$tc('interface.setting', 1) | ucfirst">
							<span class="hidden-xs">
								<i class="fa fa-percent" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-percent fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								{{ $tc('interface.setting', 1) | ucfirst }}
							</span>
						</a>
					</li>
				</ul>
			</div>
		</div>

		<template v-if="data.customer">
			<template v-if="data.customer.places">
				<template v-if="data.customer.places.length > 1">
					<places
						ref="places"
						@reload="reload"
						:data="data"
						:user="user"
						:isAuth="isAuth">
					</places>
				</template>
			</template>
		</template>

		<fab
			:type="type"
			:data="data"
			:user="user"
			:isAuth="isAuth"
			@reload="reload">
		</fab>

		<template v-if="!data.customer">
			<add-customer
				ref="addCustomer"
				@reload="reload"
				:data="data"
				:user="user"
				:isAuth="isAuth">
			</add-customer>
		</template>

		<send-email
			v-if="data"
			@reload="reload"
			ref="SendEmail"
			:item="data"
			:user="user"
			:isAuth="isAuth">
		</send-email>

		<print
			v-if="data"
			ref="Print"
			:data="data"
			:user="user"
			:isAuth="isAuth">
		</print>

		<payment-conditions
			@reload="reload"
			ref="paymentConditions"
			:data="data"
			:user="user"
			:isAuth="isAuth">
		</payment-conditions>

		<change-status
			@reload="reload"
			ref="ChangeStatus"
			:user="user"
			:isAuth="isAuth">
		</change-status>

		<assigned
			@reload="reload"
			ref="Assigned"
			:user="user"
			:isAuth="isAuth">
		</assigned>

		<settings
			ref="settings"
			@reload="reload"
			:data="data"
			:user="user"
			:isAuth="isAuth">
		</settings>

		<request-edit
			@reload="reload()"
			ref="requestEdit"
			:user="user"
			:isAuth="isAuth">
		</request-edit>
		<request-show
			@openRequestEdit="openRequestEdit"
			ref="requestShow"
			:user="user"
			:isAuth="isAuth">
		</request-show>
	</nav>
</template>

<script>
import swal from "sweetalert2";
import Fav from "./Fab";

import AddCustomer from "./AddCustomer";
import SendEmail from "./SendEmail";
import PaymentConditions from "./PaymentConditions";
import Print from "./Print";
import ChangeStatus from "./ChangeStatus";
import Assigned from "./Assigned";
import Settings from "./Settings";
import Places from "./Places";
import RequestShow from "@/components/requests/views/Show";
import RequestEdit from "@/components/requests/views/Edit";

export default {
  props: ["user", "isAuth", "data", "type"],
  components: {
    fab: Fav,

    "add-customer": AddCustomer,
    "send-email": SendEmail,
    "payment-conditions": PaymentConditions,
    print: Print,
    "change-status": ChangeStatus,
    assigned: Assigned,
    settings: Settings,
    "request-show": RequestShow,
    "request-edit": RequestEdit,
    places: Places
  },
  created() {
    this.init();
  },
  data() {
    return {
      statuses: null,
      users: null
    };
  },
  methods: {
    init() {
      this.getStatuses();
      this.getUsers();
    },
    getStatuses() {
      this.$http.get("admin/management/budgets/statuses").then(response => {
        this.statuses = response.body;
      });
    },
    getUsers() {
      var data = {
        roles: ["admin", "manager", "external_manager", "staff"]
      };
      this.$http
        .post("admin/roles/users", data)
        .then(response => {
          this.users = response.body;
        })
        .catch(function(response) {
          console.log(response);
        });
    },
    reload() {
      this.$emit("reload");
    },
    doPrint() {
      this.$refs.Print.open();
    },
    canPirnt() {
      if (this.$route) {
        if (this.$route.meta) {
          if (this.$route.meta.name) {
            if (this.$route.meta.name == "show") {
              return true;
            }
          }
        }
      }

      return false;
    },
    //--
    lock() {
      var that = this;
      if (this.data.lock) {
        var title = "Presupuesto bloqueado";
        var text = "¿Desbloquear?";
        var type = "info";

        var api = "admin/management/budgets/" + that.data.id + "/unlock";
      } else {
        var title = "Presupuesto sin bloquear";
        var text = "¿Bloquear?";
        var type = "info";

        var api = "admin/management/budgets/" + that.data.id + "/lock";
      }
      swal
        .queue([
          {
            title: title,
            text: text,
            type: type,
            showCancelButton: true,
            confirmButtonColor: "#53e69d",
            cancelButtonColor: "#ff7676",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            showLoaderOnConfirm: true,
            preConfirm: function() {
              return new Promise(function(resolve) {
                that.$http
                  .get(api)
                  .then(response => {
                    var path =
                      "/" +
                      that.$i18n.locale +
                      "/" +
                      that.$platform.slug +
                      "/admin/management/budgets/" +
                      that.data.id;
                    if (that.$route.fullPath != path) {
                      that.$router.push(
                        "/" +
                          that.$i18n.locale +
                          "/" +
                          that.$platform.slug +
                          "/admin/management/budgets/" +
                          that.data.id
                      );
                    } else {
                      that.$emit("reload");
                    }
                    swal({
                      title: response.body.title,
                      text: response.body.text,
                      type: response.body.type
                    });
                  })
                  .catch(function(response) {
                    console.log(response);
                  });
              });
            }
          }
        ])
        .catch(swal.noop);
    },
    openSettings() {
      this.$refs.settings.open();
    },
    openRequestEdit(request) {
      this.$refs.requestEdit.open(request);
    },
    removeCustomer() {
      var that = this;
      swal
        .queue([
          {
            title: this.$t("messages.attention"),
            text: "Se removerá el cliente del presupuesto",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#53e69d",
            cancelButtonColor: "#ff7676",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            showLoaderOnConfirm: true,
            preConfirm: function() {
              that.loading = true;
              return new Promise(function(resolve) {
                that.$http
                  .get(
                    "admin/management/budgets/" +
                      that.data.id +
                      "/remove/customer"
                  )
                  .then(response => {
                    that.loading = false;
                    that.$emit("reload");
                    swal({
                      title: response.body.title,
                      text: response.body.text,
                      type: response.body.type
                    });
                  })
                  .catch(function(response) {
                    that.loading = false;
                    console.log(response);
                  });
              });
            }
          }
        ])
        .catch(swal.noop);
    },
    generateOrder() {
      var that = this;
      var data = {
        currency_id: this.$platform.setting.currency_id,
        lang_id: this.$platform.setting.lang_id,
        customer_id: this.data.customer_id,
        provider_id: this.data.provider_id,
        budget_id: this.data.id
      };
      swal
        .queue([
          {
            title: that.$t("messages.attention"),
            text: "Se añadirá un pedido de venta",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#53e69d",
            cancelButtonColor: "#ff7676",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            showLoaderOnConfirm: true,
            preConfirm: function() {
              return new Promise(function(resolve) {
                that.$http
                  .post("admin/management/orders", data)
                  .then(response => {
                    that.reload();
                    swal(
                      response.body.title,
                      response.body.text,
                      response.body.type
                    );
                  })
                  .catch(function(response) {
                    if (response.status == 409) {
                      swal(
                        response.body.title,
                        response.body.text,
                        response.body.type
                      );
                    } else {
                      swal({
                        title: response.statusText,
                        text: response.body,
                        type: "warning"
                      });
                    }
                  });
              });
            }
          }
        ])
        .catch(swal.noop);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/management/budgets/views/Navbar.vue